var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.675V12.825C11.5 14.0882 11.2443 14.8423 10.7933 15.2933C10.3423 15.7443 9.58819 16 8.325 16H5.175C3.91181 16 3.15766 15.7443 2.70668 15.2933C2.2557 14.8423 2 14.0882 2 12.825V9.675C2 8.41181 2.2557 7.65766 2.70668 7.20668C3.15766 6.7557 3.91181 6.5 5.175 6.5H8.325C9.58819 6.5 10.3423 6.7557 10.7933 7.20668C11.2443 7.65766 11.5 8.41181 11.5 9.675Z",
    stroke: "#40196D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.8253 1.5H9.67531C7.08781 1.5 6.03781 2.5275 6.00781 5.0625H8.32531C11.4753 5.0625 12.9378 6.525 12.9378 9.675V11.9925C15.4728 11.9625 16.5003 10.9125 16.5003 8.325V5.175C16.5003 2.55 15.4503 1.5 12.8253 1.5Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.38b3509fcec7be2f16abcccb138fbe9b.svg";
export { ForwardRef as ReactComponent };